/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import "./InfoModal.scss";
import { PrimaryBtn } from "../../buttons/Buttons";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

/**
 *
 * Displays information passed in modal
 */
interface IProps {
  dialogContentText?: string;
  dialogTitle?: string;
  onOkClick?: () => void;
  open: boolean;
}
const InfoModal = (props: IProps) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(props.open);

  return (
    <Dialog
      open={props.open}
      // onClose={()=>setCancelOpen(false)}
      sx={{ backdropFilter: "blur(3px)" }}
    >
      <DialogTitle className="dialogHeading" id="dialog-title">
        {props.dialogTitle}
        <IconButton
          edge="end"
          color="inherit"
          onClick={() => {
            setOpen(false);
            navigate(-1);
          }}
          aria-label="close"
          sx={{ marginLeft: "auto" }}
          data-testid="closeIcon"
        >
          <CloseIcon />
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="dialogInfo">
          {props.dialogContentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          paddingRight: 4,
          paddingBottom: 4,
        }}
      >
        <PrimaryBtn
          btnText="Ok"
          onClick={() => props.onOkClick && props.onOkClick()}
          ariaLabel="Ok"
        />
      </DialogActions>
    </Dialog>
  );
};

export default InfoModal;
